export const DEFAULT_GENDER = 'male';
export const DEFAULT_DOB = '04/04/2000';
